var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('flux-vortex',{ref:"vortex",attrs:{"size":_vm.size,"circles":_vm.circles,"image":_vm.from}})}
var staticRenderFns = []

export { render, staticRenderFns }